import {useMutation} from 'react-query'

import {API} from '../../networking/http'
import {MutationMethod} from '../helpers/types'

export type CreateOpnChargeParams = undefined
export type UpdatePosTerminalProcessMutationParams = {
  id: string
  status?: string
  withQR?: boolean
  subStatus?: string
}
export type UpdatePosTerminalProcessMutationReturnType = {}
export type CreateOpnChargeMutation = MutationMethod<
  CreateOpnChargeParams,
  UpdatePosTerminalProcessMutationParams,
  UpdatePosTerminalProcessMutationReturnType
>

export const UpdatePosTerminalProcessEndpoint = (id: string) => `payments/posTerminal/${id}`
export const createPosTerminalUpdateMutation: CreateOpnChargeMutation = () => ({
  mutationFn: ({id, ...data}: UpdatePosTerminalProcessMutationParams) =>
    API.put<UpdatePosTerminalProcessMutationParams, UpdatePosTerminalProcessMutationReturnType>(
      UpdatePosTerminalProcessEndpoint(id),
      data,
    ).then((res) => res.data),
})

export const useUpdatePosTerminalProcess = () => {
  return useMutation(createPosTerminalUpdateMutation({}))
}
